import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function getAllAmbulancesApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulance,
    method: 'get',
    query
  })
}

export function addNewAmbulanceApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulance,
    method: 'post',
    query
  })
}

export function deleteAmbulanceApi(id) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulance + `/${id}`,
    method: 'delete'
  })
}

export function editAmbulanceApi(id, query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulance + `/${id}`,
    method: 'put',
    query
  })
}

export function editAmbulanceGeoFencingApi(id, query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulance + `/${id}`,
    method: 'put',
    query
  })
}

export function getAllAmbulanceEmployeeMapping(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceEmployeeMapping,
    method: 'get',
    query
  })
}